import { z } from 'zod';

export const JwtInfoSchema = z.object({
  firstName: z.string(),
  iam_domain: z.string(),
  lastName: z.string(),
  racfId: z.string().optional(),
  realm: z.string(),
  sub: z.string(),
  userId: z.string(),
});

export type JwtInfo = z.infer<typeof JwtInfoSchema>;
